/* ==========================================================================
   5pt-hero.js — Hero carousel + product card hover image swap
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Hero image URLs (will be updated with Shopify CDN URLs) ---- */
  var HERO_IMAGES = [
    'https://cdn.shopify.com/s/files/1/0654/9048/5361/files/hero-1.jpg?v=1788399437',
    'https://cdn.shopify.com/s/files/1/0654/9048/5361/files/hero-2.jpg?v=1788399436',
    'https://cdn.shopify.com/s/files/1/0654/9048/5361/files/hero-3.jpg?v=1788399437',
    'https://cdn.shopify.com/s/files/1/0654/9048/5361/files/hero-4.jpg?v=1788399436'
  ];

  /* ---- Model photo URLs by product handle ---- */
  var MODEL_PHOTOS = {
    '5-points-tattoos': 'https://cdn.shopify.com/s/files/1/0654/9048/5361/files/5-points-tattoos-model.jpg?v=1788399436',
    'dont-like-you': 'https://cdn.shopify.com/s/files/1/0654/9048/5361/files/dont-like-you-model.jpg?v=1788399437',
    'inked-mama': 'https://cdn.shopify.com/s/files/1/0654/9048/5361/files/inked-mama-model.jpg?v=1788399436',
    'inked-soul': 'https://cdn.shopify.com/s/files/1/0654/9048/5361/files/inked-soul-model.jpg?v=1788399437'
  };

  /* ---- HERO CAROUSEL ---- */
  function initHeroCarousel() {
    var hero = document.querySelector('.pt-hero');
    if (!hero) return;

    var heroImg = hero.querySelector('.pt-hero__img img');
    if (!heroImg) return;

    // Keep the original hero image as the first slide
    var originalSrc = heroImg.src;
    var allImages = [originalSrc].concat(HERO_IMAGES);

    if (allImages.length < 2) return;

    // Build carousel structure
    var carousel = document.createElement('div');
    carousel.className = 'pt-hero-carousel';
    carousel.style.cssText = 'position:absolute;inset:0;overflow:hidden;';

    var slidesContainer = document.createElement('div');
    slidesContainer.className = 'pt-hero-carousel__track';
    slidesContainer.style.cssText = 'display:flex;height:100%;transition:transform 0.8s cubic-bezier(0.16,1,0.3,1);will-change:transform;';

    allImages.forEach(function (src, i) {
      var slide = document.createElement('div');
      slide.className = 'pt-hero-carousel__slide';
      slide.style.cssText = 'flex:0 0 100%;height:100%;position:relative;overflow:hidden;';
      var img = document.createElement('img');
      img.src = src;
      img.alt = '5 Points Tees hero ' + (i + 1);
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
      slide.appendChild(img);
      slidesContainer.appendChild(slide);
    });

    // Replace the original image with the carousel
    var heroImgContainer = hero.querySelector('.pt-hero__img');
    if (!heroImgContainer) return;
    heroImgContainer.style.position = 'relative';
    heroImgContainer.innerHTML = '';
    heroImgContainer.appendChild(carousel);
    carousel.appendChild(slidesContainer);

    // Navigation arrows
    var prevBtn = document.createElement('button');
    prevBtn.className = 'pt-hero-carousel__arrow pt-hero-carousel__arrow--prev';
    prevBtn.setAttribute('aria-label', 'Previous');
    prevBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>';
    prevBtn.style.cssText = 'position:absolute;left:16px;top:50%;transform:translateY(-50%);z-index:10;background:rgba(10,10,12,0.6);border:1px solid rgba(237,237,232,0.3);color:#edede8;width:44px;height:44px;display:flex;align-items:center;justify-content:center;cursor:pointer;opacity:0;transition:opacity 0.3s;backdrop-filter:blur(4px);';

    var nextBtn = document.createElement('button');
    nextBtn.className = 'pt-hero-carousel__arrow pt-hero-carousel__arrow--next';
    nextBtn.setAttribute('aria-label', 'Next');
    nextBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>';
    nextBtn.style.cssText = 'position:absolute;right:16px;top:50%;transform:translateY(-50%);z-index:10;background:rgba(10,10,12,0.6);border:1px solid rgba(237,237,232,0.3);color:#edede8;width:44px;height:44px;display:flex;align-items:center;justify-content:center;cursor:pointer;opacity:0;transition:opacity 0.3s;backdrop-filter:blur(4px);';

    carousel.appendChild(prevBtn);
    carousel.appendChild(nextBtn);

    // Show arrows on hover
    carousel.addEventListener('mouseenter', function () {
      prevBtn.style.opacity = '1';
      nextBtn.style.opacity = '1';
    });
    carousel.addEventListener('mouseleave', function () {
      prevBtn.style.opacity = '0';
      nextBtn.style.opacity = '0';
    });

    // Click handlers
    prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goPrev(); });
    nextBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goNext(); });

    // State
    var current = 0;
    var autoTimer = null;
    var AUTO_DELAY = 2700; // 2.7 seconds

    function goTo(index) {
      current = ((index % allImages.length) + allImages.length) % allImages.length;
      slidesContainer.style.transform = 'translateX(-' + (current * 100) + '%)';
      resetAuto();
    }

    function goNext() { goTo(current + 1); }
    function goPrev() { goTo(current - 1); }

    function resetAuto() {
      if (autoTimer) clearInterval(autoTimer);
      autoTimer = setInterval(goNext, AUTO_DELAY);
    }

    // Pause on hover
    carousel.addEventListener('mouseenter', function () {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    });
    carousel.addEventListener('mouseleave', function () {
      resetAuto();
    });

    // Start auto-rotation
    resetAuto();
  }

  /* ---- PRODUCT CARD HOVER IMAGE SWAP ---- */
  function initProductCardHover() {
    var cards = document.querySelectorAll('.product-card');
    if (!cards.length) return;

    cards.forEach(function (card) {
      // Find the product handle from the card's link
      var link = card.querySelector('.product-card__link, a[href*="/products/"]');
      if (!link) return;

      var href = link.getAttribute('href') || '';
      var match = href.match(/\/products\/([^?\/]+)/);
      if (!match) return;

      var handle = match[1];
      var modelUrl = MODEL_PHOTOS[handle];
      if (!modelUrl || modelUrl.indexOf('{{') !== -1) return;

      // Find the product image
      var img = card.querySelector('img');
      if (!img) return;

      var originalSrc = img.src;
      var swapped = false;

      // Create overlay image
      var overlay = document.createElement('img');
      overlay.src = modelUrl;
      overlay.alt = 'Model wearing ' + handle;
      overlay.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity 0.3s ease;pointer-events:none;z-index:2;';
      overlay.loading = 'lazy';

      // Find the image container and append overlay
      var imgContainer = img.closest('.product-media, .media-gallery, .card-gallery, .product-card__image, slideshow-component, .slideshow__slide, .media');
      if (imgContainer) {
        imgContainer.style.position = 'relative';
        imgContainer.style.overflow = 'hidden';
        imgContainer.appendChild(overlay);
      } else {
        // Fallback: append to the card itself
        var mediaWrapper = card.querySelector('.product-card__content');
        if (mediaWrapper) {
          mediaWrapper.style.position = 'relative';
          mediaWrapper.appendChild(overlay);
        }
      }

      card.addEventListener('mouseenter', function () {
        overlay.style.opacity = '1';
      });
      card.addEventListener('mouseleave', function () {
        overlay.style.opacity = '0';
      });
    });
  }

  /* ---- INIT ---- */
  function init() {
    initHeroCarousel();
    initProductCardHover();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on section load (theme editor)
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 100);
  });
})();